import { createContext } from "react";

export const LoginProvider = createContext({
  email: "",
  setEmail: () => {},
  password: "",
  setPassword: () => {},
  step: 0,
  setStep: () => {},
  onLoginSuccess: () => {}
});
